import { render } from "./VerticalResizeBar.vue?vue&type=template&id=0b67cff2&lang=pug"
import script from "./VerticalResizeBar.vue?vue&type=script&lang=js"
export * from "./VerticalResizeBar.vue?vue&type=script&lang=js"

import "./VerticalResizeBar.vue?vue&type=style&index=0&id=0b67cff2&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__